import * as types from './boardLists.types';
export const boardListsPageSelectors: types.IBoardListPageSelectors = {
  selectBoardLists: (state) => state.page.boardLists.boardListsIds,
};
